module.exports = __webpack_public_path__ + "img/fb-messenger.38871f88.svg";